var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SwingBySwingApi } from "../services/swingbyswingapi";
import { RoundCollection, HttpResponseMessage, DriveResultType } from "../lib/types";
var Rounds = /** @class */ (function (_super) {
    __extends(Rounds, _super);
    function Rounds() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a players rounds
     *
     * @param from     The first round entry to get
     * @param limit    The last round entry to get
     */
    Rounds.prototype.getAll = function (from, to) {
        var _this = this;
        if (from === void 0) { from = 1; }
        if (to === void 0) { to = 20; }
        // Get players rounds entries and return them
        return this.request("GET", "rounds/myrounds", {
            from: from,
            to: to
        }).then(function (r) {
            // Map entries to type
            return _this.mapResponse(new RoundCollection(), r.data);
        });
    };
    Rounds.prototype.getSpecific = function (roundId) {
        return this.request("GET", "rounds/" + roundId).then(function (r) {
            return r.data;
        });
    };
    /**
     * Deletes a round for a player
     *
     * @param roundId The handicap to delete
     */
    Rounds.prototype["delete"] = function (roundId) {
        var _this = this;
        // Delete the handicap
        return this.request("DELETE", "rounds/" + roundId).then(function (r) {
            // Return the mapped response
            return _this.mapResponse(new HttpResponseMessage(), r.data);
        });
    };
    /**
     * Returns round stats
     *
     * @param from          The first entry to get
     * @param to            The last entry to get
     * @param createdAfter  The date to start on
     * @param createdBefore The date to end on
     */
    Rounds.prototype.stats = function (from, to, createdAfter, createdBefore) {
        if (from === void 0) { from = 1; }
        if (to === void 0) { to = 20; }
        if (createdAfter === void 0) { createdAfter = null; }
        if (createdBefore === void 0) { createdBefore = null; }
        var _a, _b;
        return this.request("GET", "roundextendedstats", {
            from: from,
            to: to,
            createdAfter: (_a = createdAfter) === null || _a === void 0 ? void 0 : _a.format("YYYY-MM-DDT00:00:00-05:00"),
            createdBefore: (_b = createdBefore) === null || _b === void 0 ? void 0 : _b.format("YYYY-MM-DDT00:00:00-05:00")
        }).then(function (r) {
            return r.data;
        });
    };
    Rounds.prototype.updateScorecard = function (scorecardId, roundId, playerId, holes) {
        return this.request("PUT", "scorecards/" + scorecardId, {
            roundId: roundId,
            playerId: playerId,
            holes: holes
        });
    };
    /**
     * Get drive types
     */
    Rounds.prototype.driveTypes = function () {
        var _this = this;
        return this.request("GET", "driveResultTypes").then(function (r) {
            var driveTypes = r.data;
            return driveTypes.map(function (d) {
                // Map drive type
                var driveType = _this.mapResponse(new DriveResultType(), d);
                // Return mapped drive types
                return driveType;
            });
        });
    };
    return Rounds;
}(SwingBySwingApi));
export { Rounds };
